import { InertiaApp } from '@inertiajs/inertia-vue'
import Vue from 'vue'
import PortalVue from 'portal-vue'
import VueToastr from "vue-toastr"
import VueInternationalization from 'vue-i18n'
import Locale from './vue-i18n-locales.generated'
import moment from 'moment'
import './icons'
import axios from 'axios';
import Echo from "laravel-echo"
import Pusher from 'pusher-js';
import number_format from '@/Utils/number_format';
$ = jQuery = require('jquery');
import './cookie';
import './text-editor-config';

const VueUploadComponent = require('vue-upload-component');
// Vue.component('pagination', require('laravel-vue-pagination'));

Vue.use(InertiaApp);
Vue.use(PortalVue);
Vue.use(VueInternationalization);
Vue.use(VueToastr);
// Vue.use(VueRepeater);

let currentUser = null;
let impersonatingUser = null;
const app = document.getElementById('app');
const lang = document.documentElement.lang.substr(0, 2);
const i18n = new VueInternationalization({
    locale: lang,
    messages: Locale,
    fallbackLocale: 'en',
});

let $pageProps = {};

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: window.Laravel.pusher_app_key,
    cluster: 'eu',
    forceTLS: true
});

// axios.defaults.headers.common = {
//     'X-Requested-With': 'XMLHttpRequest',
//     'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
// };

Vue.mixin({
    methods: {
        currentLocale: () => {
            return document.documentElement.lang.substr(0, 2);
        },
        impersonatingRole: (roleName) => {
            if(impersonatingUser) {
                if (impersonatingUser.roles.filter(role => role.name === roleName).length !== 0) {
                    return true;
                }
            }

            return false;
        },
        hasRole: (roleName) => {
            if (currentUser) {
                if (currentUser.roles.filter(role => role.name === roleName).length !== 0) {
                    return true;
                }
            }

            return false;
        },
        hasRolePermission: (permissionName) => {

            let hasPermission = false;
            if (currentUser) {
                currentUser.roles.forEach(role => {
                    if (role.permissions.filter(permission => permission.name === permissionName).length !== 0) {
                        hasPermission = true;
                    }
                });
            }

            return hasPermission;
        },
        route: (...args) => {
            if (args[0] === 'current') {
                args.shift();
                return window.route(window.route().current(), ...args).url();
            }

            return window.route(...args).url();
        },
        csrf: () => document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        isUrl(...urls) {
            if (urls[0] === '') {
                return location.pathname.substr(1) === ''
            }

            return !!urls.filter(url => url.endsWith(location.pathname.substr(0))).length;
        },
        isRoute(route, params = {}, exact = false) {

            const routeUrl = params ? this.route(route, params) : this.route(route);
            if (this.isUrl(routeUrl)) {
                return true;
            }
            const routePath = /https?:\/\/[^\/]+(.*)/.exec(routeUrl)[1];

            return exact ? route === routePath : location.pathname.startsWith(routePath);
        }
    }
});

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm')
    } else {
        return '-';
    }
});
Vue.filter('formatDateTime24', function (value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY HH:mm')
    } else {
        return '-';
    }
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
    } else {
        return '-';
    }
});

Vue.filter('money', (value) => {
    return number_format(parseFloat(value), 2) + ' ' + $pageProps.currency.symbol;
});

Vue.filter('numberFormat', (value) => {
    return number_format(parseFloat(value), 2);
});

window.stripHTML = function(value){
    const div = document.createElement('div')
    div.innerHTML = value
    const text = div.textContent || div.innerText || ''
    return text
}

Vue.filter('stripHTML', window.stripHTML);

new Vue({
    i18n,
    mounted() {
        this.$toastr.defaultPosition = 'toast-top-center';
    },
    created: () => {
        $pageProps = JSON.parse(app.dataset.page).props;
    },
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            transformProps: (props) => {
                $pageProps = props;
                currentUser = props.auth.user;
                impersonatingUser = props.auth.original_user;
                i18n.locale = props.app.locale;

                return props;
            },
            resolveComponent: (name) => {
                return import(`@/Pages/${name}`).then(module => {
                    return module.default;
                })
            },
        }
    }),

}).$mount(app);

import './cookie';
